import React from 'react'
import PropTypes from 'prop-types'

const preventDefault = e => e.preventDefault()

/**
 * A component used to catch click event
 */
const ClickCatcher = ({ as: Wrapper, ...domProps }) => <Wrapper {...domProps} onClick={preventDefault} />

ClickCatcher.defaultProps = {
  as: 'span',
}

ClickCatcher.propTypes = {
  /**
   * The wrapper
   */
  as: PropTypes.elementType,
}

export default ClickCatcher
